import React from "react";
import SEO from "../components/SEO";
import { PageHero, SectionHeading, CheckList, CTABand } from "../components/ui-blocks";
import { hipaa } from "../mock/mock";

export default function HipaaPolicies() {
  return (
    <>
      <SEO
        title="HIPAA Privacy Policies — How We Protect Patient & Insurance Data"
        description="VerifiAssist follows HIPAA-conscious workflows and secure data-handling processes to protect patient and insurance information in every verification and interaction."
        path="/hipaa-privacy-policies"
      />
      <PageHero eyebrow={hipaa.hero.eyebrow} title={hipaa.hero.title} subtitle={hipaa.hero.subtitle} />

      <section className="container-x py-16 sm:py-20">
        <div className="grid gap-12 lg:grid-cols-3">
          <div className="lg:col-span-2 space-y-8">
            {hipaa.sections.map((s) => (
              <div key={s.title}>
                <h2 className="text-xl font-bold text-brand-navy">{s.title}</h2>
                <p className="mt-3 text-slate-600 leading-relaxed">{s.body}</p>
              </div>
            ))}
          </div>
          <aside className="h-fit rounded-3xl border border-slate-200 bg-slate-50 p-7">
            <h3 className="text-lg font-semibold text-brand-navy">Our safeguards</h3>
            <div className="mt-5"><CheckList items={hipaa.points} /></div>
          </aside>
        </div>
      </section>

      <CTABand title="Questions about security or compliance?" body="Contact us to learn more about our process, safeguards and support model." primaryLabel="Contact Us" />
    </>
  );
}
